import React from 'react';

// Define a type for all playable IDs to get type checking
export type PlayableId = 'uno' | 'connectFour' | 'checkers' | 'youtube';

// Type for the lazy-loaded components with proper generics
type PlayableComponent<P = any> = React.LazyExoticComponent<React.ComponentType<P>>;

// Lazy load each playable component with proper typing
export const Uno: PlayableComponent = React.lazy(() => import('./uno/Uno'));
export const ConnectFour: PlayableComponent = React.lazy(() => import('./connectFour/ConnectFour'));
export const Checkers: PlayableComponent = React.lazy(() => import('./checkers/Checkers'));
export const YouTube: PlayableComponent = React.lazy(() => import('./youtube/YouTube'));

// Map of all playables for programmatic access
// This replaces the previous default export with a more useful typed map
export const playableComponents: Record<PlayableId, PlayableComponent> = {
  uno: Uno,
  connectFour: ConnectFour,
  checkers: Checkers,
  youtube: YouTube
};

// We're removing the default export because named exports are clearer
// and provide better typing in TypeScript